/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Helpers, Redux, Templates } from "@ora/recursos";

import axios from "axios";
import { Link } from "react-router-dom";
import { Chart } from "react-google-charts";


const { set_datapage, getMapStateDefault } = Redux.Actions.DataPageAction;
const { baseUrl, baseUrlModule, localUrl } = Helpers.Url;
const { checkDataDirectorio, seDatatDocumentos } =
  Redux.Actions.DirectoriosActions;

const VIEW_SESSION_NAME = "NOMBRE_UNICO_PARA_LAVISTA_ACTUAL_PUBLIC";

class Public extends Component {
  requestInit = null;
  state = {
    exportadores: [],
    importadores:[],
    years:[],
    presentacion:[],
    completeTotal:[],
    typeinfo:-1

  };
  constructor(props) {
    super(props);

    this.requestInit = axios.CancelToken.source();
    //opcional
    // this.props.checkDataDirectorio(VIEW_SESSION_NAME).then((resCheck) => {
    //   if (!resCheck.success) {
    //     this.__getDataInitial();
    //   } else {
    //     this.initpage(resCheck.data);
    //   }
    // });
  }

  __getDataInitial() {
    axios
      .get(baseUrlModule("listaprueba"), {
        params: {
          // especie: this.props.especie.pli_int_id,
          // id: this.props.especie.pli_int_id,
          // onlyquery: false,
          // variables_distribution: this.variables_distribution
        },
        cancelToken: this.requestInit.token,
      })
      .then((res) => {
        if (res.data.success) {
          let _preData = {
            session: VIEW_SESSION_NAME,
            data: res.data.data,
            time: Date.now(),
          };
          this.props
            .seDatatDocumentos(_preData)
            .then((resSet) => {
              this.initpage(_preData);
            })
            .catch((err) => {});
        }
      });
  }

  initpage(result) {
    //DATOS NECESARIOS PARA LA VISTA POR DEFECTO, SOLO SI FUERAN ENCESARIOS
    // this.setState({
    //   lista: result.data,
    // });
  }
  componentDidMount() {
    this.setDataPage();
    axios.get(baseUrlModule('reportes/graficosTotales')).then((res) => {
      this.setState({
        exportadores: res.data.exportadores,
        importadores:res.data.importadores,
        years:res.data.years,
        presentacion:res.data.presentacion,
        completeTotal:res.data.cantidadoperaciones

      });
    });
  }

  componentWillUnmount() {
    if (this.requestInit) this.requestInit.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (100 === +this.props.countDataPage) {
      this.setDataPage();
    }
  }

  cantidadOperaciones=()=>{
    var cantidad='';
    this.state.completeTotal.filter((item)=>(item.var_txt_key==this.state.typeinfo)).map((item)=>{
        cantidad=item.cantidad;
        
    })

    return cantidad;
  }

  exportadoresOption=()=>{
    if(this.state.exportadores.length>0){
        var exporta=[["Pizza", "Popularity"]];
        this.state.exportadores.filter((item)=>(item.var_txt_key==this.state.typeinfo)).map((item)=>{
            exporta.push([item.var_txt_description,parseInt(item.cantidad)]);
    
        });
        return exporta;
    }
  }

  importadoresOption=()=>{
    if(this.state.importadores.length>0){
        var importa=[["Pizza", "Popularity"]];
        this.state.importadores.filter((item)=>(item.var_txt_key==this.state.typeinfo)).map((item)=>{
            importa.push([item.var_txt_description,parseInt(item.cantidad)]);
    
        });
        return importa;
    }
  }

  yearOption=()=>{
    if(this.state.years.length>0){
        var year=[["Pizza", "Popularity"]];
        this.state.years.filter((item)=>(item.var_txt_key==this.state.typeinfo)).map((item)=>{
            year.push([item.exp_int_year,parseInt(item.cantidad)]);
    
        });
        return year;
    }
  }

  presentacionOption=()=>{
    if(this.state.presentacion.length>0){
        var importa=[["Pizza", "Popularity"]];
        this.state.presentacion.filter((item)=>(item.var_txt_key==this.state.typeinfo)).map((item)=>{
            importa.push([item.var_txt_name,parseInt(item.cantidad)]);
    
        });
        return importa;
    }
  }

  examplePost = () => {
    let data = {};
    axios
      .post(baseUrl("aro/downloads"), data, {
        cancelToken: this.requestInit.token,
      })
      .then((resCre) => {});
  };

  setDataPage = () => {
    this.props.set_datapage({
      titulo: this.props.language("titulo_para_public", "Titulo dashboard - exportaciones totales"),
      isbackend: false,
      hasBreadcrumb: false,
      hasHeroBar: true,
      be_itemselect: "exportaciones_cites", //clave de item del menu backend que se debe activar
      breadcrumb: [
        { name: "Inicio", url: localUrl("/") },
        { name: "Reportes", url: "#" },
        { name: "Biodiversidad", url: "#", active: true },
      ],
    });
  };

  urlWithPublicToken = () => {
    return baseUrl(
      `nombremoduloejemplo/public/anyword?token=${Helpers.ValidationAuth.getPublicAuthorization()
        .replace("Basic", "")
        .replace(" ", "")
        .trim()}`
    );
  };
  render() {

    const data =this.exportadoresOption();

    const options = {
        title: "Por PM Exportador:",
        /* sliceVisibilityThreshold: 0.2, // 20% */
      };

    const dataimportadores =this.importadoresOption();

    const optionsimportadores = {
        title: "Por país Destino:",
        sliceVisibilityThreshold: 0.018, // 20%
     };

     const datayear =this.yearOption();

     const optionsyear = {
         title: "Por años:",
        sliceVisibilityThreshold: false,
      };

    const datapresentacion =this.presentacionOption();

    const optionspresentacion = {
        title: "Por tipo de presentación:",
        sliceVisibilityThreshold: 0.005,
    };

    const handleChange=(event)=> {
        this.setState({
          typeinfo: event.target.value,
        });
      
      }
    return (

      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >



<div className="columns">
<div className="column is-2">
              <div className="field">
                <label className="label">
                  Origen de datos:
                </label>
                <div className="control is-expanded">
                  <span className="select is-empty is-fullwidth">
                    <select  onChange={(event) => handleChange(event)}                       
                     disabled={
                        this.state.exportadores.length === 0
                      }>
                     <option value="-1">
                       -- {this.props.language("sel_todos")}--
                     </option>
                       {/* <option value="-1">-- Seleccione--</option> */}
                       <option value="exports_cites.org">CITES.ORG</option>
                       <option value="exports_otca">Instituciones Oficiales de los Países Miembros</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
</div>


{this.state.typeinfo!==-1?(
    <>
            <div className="columns">  
         
         <div className="column">
             <h3><b>Total Operaciones en los PM: </b> {this.cantidadOperaciones()}</h3>
         </div>         
     </div>

     <div className="columns">
         <div className="column">
             {this.state.exportadores.length>0?(
                                 <Chart
                                 chartType="PieChart"
                                 data={data}
                                 options={options}
                                 width={"100%"}
                                 height={"400px"}
                             />
             ):<></>}
         </div>
         <div className="column">

         {this.state.exportadores.length>0?(
                                 <Chart
                                 chartType="PieChart"
                                 data={dataimportadores}
                                 options={optionsimportadores}
                                 width={"100%"}
                                 height={"400px"}
                             />
             ):<></>}
         </div>
     </div>
     <div className="columns">
         <div className="column">
         {this.state.exportadores.length>0?(
                                 <Chart
                                 chartType="PieChart"
                                 data={datayear}
                                 options={optionsyear}
                                 width={"100%"}
                                 height={"400px"}
                             />
             ):<></>}
         </div>
         <div className="column">
         {this.state.exportadores.length>0?(
                                 <Chart
                                 chartType="PieChart"
                                 data={datapresentacion}
                                 options={optionspresentacion}
                                 width={"100%"}
                                 height={"400px"}
                             />
             ):<></>}
         </div>
     </div>
    </>
):<>Seleccionar fuente de información</>}


    
    
            
</Templates.Default.BasePageRoute2>

      
    );
  }
}

export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(Public);
